<template>
	<div>
		<v-card elevation="3">
			<v-form @submit.prevent>
				<v-card-title>
					<div>
						{{ $T('title') }}
						<br />
						{{ details.name }} |
						<span dir="ltr">
							{{ moment(details.date).format('L') }}
						</span>
					</div>
					<v-spacer></v-spacer>
					<v-btn
						@click="$emit('close'); clear()"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<bee-handy-table
						table-class="block-border overflow-hidden"
						:headers="headers"
						:items="items"
						ref="table"
						:loading="!!loadingFetch || loading"
						:data-table-props="{ disableSort: true }"
						dense
						zebra
						fixed-header
						height="300"
						hide-default-footer
					>
						<template v-slot:item.type="{ item }">
							<tooltip :text="$T('tooltips.device')">
								<v-icon
									small
									v-if="item.type === fingerTypeEnum.device">
									mdi-fingerprint
								</v-icon>
							</tooltip>
							<tooltip :text="$T('tooltips.updated')">
								<v-badge
									v-if="item.type === fingerTypeEnum.updated"
									color="grey--text"
									icon="$edit"
									overlap
									left
									bottom>
									<v-icon small> mdi-fingerprint </v-icon>
								</v-badge>
							</tooltip>
							<tooltip :text="$T('tooltips.inserted')">
								<v-icon v-if="item.type === fingerTypeEnum.inserted" small>
									mdi-server-outline
								</v-icon>
							</tooltip>
						</template>

						<template v-slot:item.actions="{ item }">
							<div class="d-flex">
								<!-- edit enter -->
								<tooltip :text="$T('tooltips.edit-enter')">
									<v-btn
										icon
										min-width="0"
										width="30"
										height="30"
										color="edit-color"
										class="me-1"
										:disabled="Object.keys(item.enterData).length === 0"
										@click="
											showAddFingerprintDialog = true;
											fingerprintId = item.enterData.id;
											fillToEdit(true);
										"
									>
										<v-icon>mdi-clock-start</v-icon>
									</v-btn>
								</tooltip>

								<!-- edit leave -->
								<tooltip :text="$T('tooltips.edit-leave')">
									<v-btn
										icon
										min-width="0"
										width="30"
										height="30"
										color="edit-color"
										:disabled="Object.keys(item.leaveData).length === 0"
										@click="
											showAddFingerprintDialog = true;
											fingerprintId = item.leaveData.id;
											fillToEdit(false);
										"
									>
										<v-icon>mdi-clock-end</v-icon>
									</v-btn>
								</tooltip>
							</div>
						</template>
					</bee-handy-table>
				</v-card-text>
				<v-card-actions>
					<v-btn
						:disabled="!!loadingFetch"
						:loading="!!loadingFetch"
						color="secondary"
						@click="showAddFingerprintDialog = true">
						{{ $T('default-buttons.add') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="$emit('close');">
						{{ $T('default-buttons.cancel') }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>

		<v-dialog
			v-model="showAddFingerprintDialog"
			max-width="350px"
			transition="dialog-transition"
			@input="!$event ? clear() : null"
		>
			<v-card elevation="3">
				<v-form @submitprevent="addFingerprint">
					<v-card-title>
						{{!fingerprintId ? 'إضافة بصمة' : 'تعديل بصمة'}}
						<v-spacer></v-spacer>
						<v-btn
							@click="showAddFingerprintDialog = false; clear()"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="4">
								<v-btn-toggle
									v-model="fingerPrintData.isArrival"
									color="primary"
									mandatory
									dense
								>
									<v-btn
										small
										:value="true"
										:disabled="!fingerPrintData.isArrival && Boolean(fingerprintId)"
									>
										دخول
									</v-btn>
									<v-btn
										small
										:value="false"
										:disabled="fingerPrintData.isArrival && Boolean(fingerprintId)"
									>
										خروج
									</v-btn>
								</v-btn-toggle>
							</v-col>
							<v-col cols="8">
								<v-text-field
									v-model="fingerPrintData.time"
									type="time"
									label="الوقت"
									outlined
									dense
									hide-details>
								</v-text-field>
							</v-col>
							<v-col cols="12">
								<v-textarea
									v-model="fingerPrintData.notes"
									:label="$t('inputs.notes')"
									auto-grow
									rows="2"
									outlined
									dense
									hide-details>
								</v-textarea>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							:disabled="!!loadingFetch || loadingAddingFingerprint || !fingerPrintData.time"
							:loading="!!loadingFetch || loadingAddingFingerprint"
							type="submit"
							color="secondary"
							@click="addFingerprint">
							{{ $T('default-buttons.save') }}
						</v-btn>

						<v-btn @click="showAddFingerprintDialog = false; clear();">
							{{ $T('default-buttons.cancel') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { diff, TIME_FORMAT } from '@/utils/moment';
import moment from 'moment';
import { fingerPrintStatus } from '@/utils/enum';
const fingerTypeEnum = {
	device: 1,
	updated: 2,
	inserted: 3,
};

export default {
	name: 'BFingerprintDialog',

	props: {
		data: { type: Array },
		details: { type: Object },
		loadingFetch: { type: String },
	},

	data() {
		return {
			loading: false,

			headers: [
				{
					test: '',
					value: 'type',
					name: 'type',
					width: 20,
				},
				{
					text: this.$T('headers.enterPrint'),
					value: 'enterData.time',
					name: 'enterTime',
				},
				{
					text: this.$T('headers.leavePrint'),
					value: 'leaveData.time',
					name: 'leaveTime',
				},
				{
					text: this.$T('headers.duration'),
					value: 'duration',
					name: 'duration',
				},
				{
					text: '',
					value: 'actions',
					name: 'actions',
					width: 30,
				},
			],

			fingerTypeEnum,

			showAddFingerprintDialog: false,
			loadingAddingFingerprint: false,
			fingerPrintData: {
				time: null,
				isArrival: false,
				notes: null,
				changeStatus: null,
			},

			fingerprintId: null,
		};
	},

	computed: {
		items() {
			const convertToDate = (value) => {
				return value && moment(value).isValid() ? moment(value).format(TIME_FORMAT) : null;
			};
			const getStatus = (f, s) => {
				if (f === fingerTypeEnum.inserted || s === fingerTypeEnum.inserted)
					return fingerTypeEnum.inserted;

				if (f === fingerTypeEnum.updated || s === fingerTypeEnum.updated)
					return fingerTypeEnum.updated;
				return fingerTypeEnum.device;
			};

			const temp = [];
			for (let i = 0; i < this.data.length; i++) {
				const enterObj = {};
				if (this.data[i].arrivalTime || this.data[i].newArrivalTime) {
					enterObj.id = this.data[i].id;
					enterObj.isArrival = true;
					
					enterObj.type = this.data[i].fingerPrintStatus;
					enterObj.dateTime = this.data[i].arrivalTime || this.data[i].newArrivalTime;
					enterObj.time = convertToDate(enterObj.dateTime) || '-';
					enterObj.notes = this.data[i].note;
				}

				const leaveObj = {};
				const getLeaveObjDate = (data) => {
					leaveObj.id = data.id;
					leaveObj.isArrival = false;

					leaveObj.type = data.fingerPrintStatus;
					leaveObj.dateTime = data.departureTime || data.newDepartureTime;
					leaveObj.time = convertToDate(leaveObj.dateTime) || '-';
					leaveObj.notes = data.note;
				}
				if (this.data[i].departureTime || this.data[i].newDepartureTime) {
					getLeaveObjDate(this.data[i])
				} else if (this.data[i + 1]?.departureTime || this.data[i + 1]?.newDepartureTime) {
					getLeaveObjDate(this.data[i + 1])
					i++;
				}

				temp.push({
					data: this.data[i],
					type: getStatus(enterObj.type, leaveObj.type),
					enterData: enterObj,
					leaveData: leaveObj,
				});
			}

			return temp.map((c) => ({
				...c,
				duration: diff(c.leaveData.dateTime, c.enterData.dateTime),
			}));
		},
	},

	methods: {
		addFingerprint() {
			this.loadingAddingFingerprint = true;
			const actionName = !this.fingerprintId ? 'addOneFingerprint' : 'editFingerprint' 
			this.$store.dispatch(`attendance/${actionName}`, {
					id: this.fingerprintId,
					time: this.fingerPrintData.time,
					isArrival: this.fingerPrintData.isArrival,
					notes: this.fingerPrintData.notes,
					employeeId: this.details.employeeId,
					date: this.details.date,
					fingerPrintStatus: fingerPrintStatus.modified,
				}).then(() => {
					this.$eventBus.$emit(
						'show-snackbar',
						!this.fingerprintId ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
				}).catch((err) => {
					err.default && err.default(
						!this.fingerprintId ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						false
					);
				}).finally(() => {
					this.clear();
					this.showAddFingerprintDialog = false;
					this.loadingAddingFingerprint = false;
					this.$emit('re-fetch', this.details);
				});
		},
		fillToEdit(isArrival) {
			const fingerprint = this.items.find(
				c => c[isArrival ? 'enterData' : 'leaveData'].id === this.fingerprintId
			);
			const stateData = fingerprint[isArrival ? 'enterData' : 'leaveData'];
			this.fingerPrintData.time = moment(stateData.dateTime).format('HH:mm');
			this.fingerPrintData.isArrival = stateData.isArrival;
			this.fingerPrintData.notes = fingerprint.notes;
			// this.fingerPrintData.changeStatus = fingerprint.changeStatus;
		},
		clear() {
			this.fingerPrintData.time = null;
			this.fingerPrintData.isArrival = false;
			this.fingerPrintData.notes = null;
			this.fingerPrintData.changeStatus = null;
			this.fingerprintId = null;
		},
		moment,
	},
};
</script>

<style></style>
